/**
 * Module dependencies.
 */

import { NextPage } from 'next';
import { media } from 'src/styles/media';
import Footer from 'src/components/footer';
import Metatags from 'src/components/core/metatags';
import StartTourSection from 'src/components/sections/start-tour-section';
import TriggerNavbarTheme, {
  useInitialNavbarTheme
} from 'src/components/navbar/trigger-navbar-theme';

import TripContentSection from 'src/components/sections/trip-content-section';
import TripHeaderSection from 'src/components/sections/trip-header-section';
import TripPlacesSection from 'src/components/sections/trip-places-section';
import styled from 'styled-components';
import useTranslate from 'src/hooks/use-translate';

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  background-color: var(--color-grey-100);
  color: var(--color-dark);
  padding-top: 8rem;

  ${media.min.md`
    padding-top: 10.5rem;
  `}
`;

/**
 * `TripToPortugal` page.
 */

const TripToPortugal: NextPage = () => {
  const { translate } = useTranslate();

  useInitialNavbarTheme('dark');

  return (
    <>
      <Metatags
        title={`${translate(
          'trip-to-portugal:headerSection.title'
        )} ${translate('trip-to-portugal:headerSection.subtitle')}`}
      />

      <TriggerNavbarTheme colorTheme={'dark'} />

      <Wrapper>
        <TripHeaderSection />

        <TripContentSection />

        <TripPlacesSection />

        <TriggerNavbarTheme colorTheme={'light'} />

        <StartTourSection />
      </Wrapper>

      <Footer />
    </>
  );
};

/**
 * Export `TripToPortugal` page.
 */

export default TripToPortugal;
